import {
  GoogleAuthProvider,
  signInWithPopup,
  getAuth,
  User,
} from "firebase/auth";
import { createOrUpdateProviderUser } from "../../../infrastructure/repositories/providerUserRepository";
import * as Sentry from "@sentry/react";
import { ProviderUser } from "../../types/ProviderUser";

export const signOut = () => {
  const auth = getAuth();
  Sentry.setUser(null);
  auth.signOut();
};

export const signIn = async (options?: {
  forceNewAppUserId?: boolean;
  familyId?: string;
}) => {
  console.log("Starting sign-in process");
  const auth = getAuth();
  const existingProviderUser = auth.currentUser as User | null;
  const provider = new GoogleAuthProvider();

  provider.setCustomParameters({
    prompt: "select_account",
    access_type: "offline",
  });

  try {
    console.log("Attempting popup sign-in");
    const result = await signInWithPopup(auth, provider);
    console.log("Sign-in successful", result);

    const newProviderUser = result.user as ProviderUser;

    console.debug("authService: existingProviderUser", existingProviderUser);
    console.debug("authService: newProviderUser", newProviderUser);

    await createOrUpdateProviderUser(
      existingProviderUser,
      newProviderUser,
      options,
    );

    return result;
  } catch (error: any) {
    if (error.code === "auth/popup-closed-by-user") {
      console.log("Sign-in cancelled by user");
      return null;
    }
    console.error("Error with sign-in:", error);
    throw error;
  }
};
